module.exports = __webpack_public_path__ + "static/img/zbzc_icon.bc0dce5b.png";